import {sendLogglyEvent} from "Helpers/loggly";
import {IS_DEV} from "Setup/config";

// The Daily Shop Wheel's Loggly category, which its customField parse errors
// (sendLogglyEventForGambitGame) already use. sendLogglyEvent adds the player's id, so a search on
// the category and a player id shows that player's journey (see bonusing.md, "Tracing a player").
export const WHEEL_LOG_CATEGORY = "GambitDailyShopWheel";

const toIso = (time) => (time ? new Date(time).toISOString() : null);

// Where the player is with the wheel, from the game's hook (useGambitDailyShopWheel): sent with
// every entry, so each one can be read on its own.
export const wheelState = (game) => {
    const progress = game?.wageringProgress;

    return {
        activationId: progress?.activationId ?? null,
        wagering: progress?.state ?? "none",
        status: progress?.status ?? null,
        staked: progress?.current ?? null,
        target: progress?.target ?? null,
        activatedAt: toIso(progress?.activatedAt),
        completedAt: toIso(progress?.completedAt),
        mastergroup: Boolean(game?.gambitGameMastergroupBonus),
        prize: game?.gambitGamePrizeBonus?.internalName ?? null,
        canView: Boolean(game?.canViewGambitGame),
        canSpin: Boolean(game?.canPlayGambitGame),
        testMode: Boolean(game?.isTestMode),
    };
};

// Logs a step of the player's journey with the wheel, with where they are as `game` sees it. In
// development it's shown in the console too, as Loggly usually isn't loaded there.
export const logWheel = (message, game, details = {}) => {
    const json = {...wheelState(game), ...details};
    if (IS_DEV) console.info(`[${WHEEL_LOG_CATEGORY}] ${message}`, json);
    sendLogglyEvent(WHEEL_LOG_CATEGORY, message, json);
};

// What this device has already logged once (see useLogWheelJourney), in localStorage, which may
// be unavailable (private windows): then it's logged again on each page.
const LOGGED_KEY = "gambitDailyShopWheelLogged";
const KEEP = 50;

const readLogged = () => {
    try {
        const keys = JSON.parse(localStorage.getItem(LOGGED_KEY));
        return Array.isArray(keys) ? keys : [];
    } catch (e) {
        return [];
    }
};

// Whether `key` hasn't been logged on this device before, noting it if not.
export const isFirstOnDevice = (key) => {
    const keys = readLogged();
    if (keys.includes(key)) return false;

    try {
        localStorage.setItem(LOGGED_KEY, JSON.stringify([key, ...keys].slice(0, KEEP)));
    } catch (e) {
        // Nothing to keep it in.
    }

    return true;
};
